import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { companyInfo } from '../data/mock';
import './landing.css';

export const GateMark = () => (
  <svg viewBox="0 0 32 32" className="h-7 w-7" aria-hidden="true">
    <line x1="1" y1="11" x2="8" y2="11" stroke="var(--pcb-silk)" strokeWidth="2" />
    <line x1="1" y1="21" x2="8" y2="21" stroke="var(--pcb-silk)" strokeWidth="2" />
    <path d="M8,5 h8 a11,11 0 0 1 0,22 h-8 z" fill="none" stroke="var(--pcb-silk)" strokeWidth="2" />
    <circle cx="29" cy="16" r="2.5" fill="var(--pcb-led)" />
  </svg>
);

const NAV_LINKS = [
  { label: 'Products', href: '/#products' },
  { label: 'Logic Wiki', to: '/logic-wiki' },
  { label: 'About', to: '/about' },
  { label: 'Contact', href: '/#contact' },
];

const PcbHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // On the landing page a plain same-page anchor scrolls natively; from inner
  // pages a router Link avoids a full SPA reload (LandingPage handles the hash).
  const renderLink = (l, onClick) =>
    l.href ? (
      location.pathname === '/' || (l.label === 'Contact' && /^\/product\/(logic-gates|logic-learner)\/?$/.test(location.pathname)) ? (
        <a key={l.label} href={l.label === 'Contact' ? '#contact' : l.href} className="pcb-nav-link" onClick={onClick}>
          {l.label}
        </a>
      ) : (
        <Link key={l.label} to={l.href} className="pcb-nav-link" onClick={onClick}>
          {l.label}
        </Link>
      )
    ) : (
      <Link
        key={l.label}
        to={l.to}
        className="pcb-nav-link"
        onClick={() => {
          window.scrollTo(0, 0);
          if (onClick) onClick();
        }}
      >
        {l.label}
      </Link>
    );

  return (
    <header className="pcb-header" role="banner">
      <div className="container mx-auto px-6 py-3.5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" onClick={() => window.scrollTo(0, 0)}>
          <GateMark />
          <span className="flex flex-col leading-tight">
            <span className="pcb-mono font-semibold text-lg">{companyInfo.name}</span>
            <span className="pcb-mono text-xs" style={{ color: 'var(--pcb-silk-dim)' }}>
              {companyInfo.website}
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7" role="navigation" aria-label="Main navigation">
          {NAV_LINKS.map((l) => renderLink(l))}
        </nav>

        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden flex flex-col gap-1.5 p-2"
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <span className="w-6 h-0.5 block" style={{ background: 'var(--pcb-silk)' }} />
          <span className="w-6 h-0.5 block" style={{ background: 'var(--pcb-silk)' }} />
          <span className="w-6 h-0.5 block" style={{ background: 'var(--pcb-silk)' }} />
        </button>
      </div>

      {mobileMenuOpen && (
        <nav
          className="md:hidden border-t px-6 py-4 flex flex-col gap-4"
          style={{ borderColor: 'var(--pcb-line)' }}
          role="navigation"
          aria-label="Mobile navigation"
        >
          {NAV_LINKS.map((l) => renderLink(l, () => setMobileMenuOpen(false)))}
        </nav>
      )}
    </header>
  );
};

export default PcbHeader;
